import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/repos/[id]/RepoDetailClient.tsx");
